<branding-wrapper [brandingData]="brandingData" 
  [ngClass]="{ noBranding: !brandingData }"
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'"
>
  <div class="loading" *ngIf="!!loading">loading...</div>
  <div class="error" *ngIf="!!unavailable" [innerHTML]="helpers.strWithBreak(unavailableMessage)"></div>
  <shared-timeline-wrapper
    *ngIf="!loading && !unavailable"
    [eventTitle]="eventTitle"
    [loading]="loading"
    [madeWithJoi]="false"
    [unavailable]="unavailable"
    [unavailableMessage]="unavailableMessage"
    [showExtraFilters]="true"
    [showExpandContract]="true"
    (expandAll)="expandAll()"
    (collapseAll)="collapseAll()"
  >
    <ng-container *ngFor="let p of programs; trackBy: trackById">
      <expanding-wrapper
        class="program"
        *ngIf="{ date: p | programDayDate, 
          roomToggleKey: p.id + ':room' 
        } as pVars"
        [padded]="true"
        [expandedState]="!expandedStates[p.id] ? 'collapse' : 'expand'"
        [manualToggle]="true"
        (onToggle)="expandedStates[p.id] = !expandedStates[p.id]"
        [borderGreyOnCollapse]="true"
      >
        <div class="header-left">
          <div class="times-labels">
            <h4 [ngClass]="{ missing: !p.title }">{{ p.title || 'Unnamed Room/Location' }}</h4>
          </div>
        </div>

        <div class="empty" *ngIf="!p.sessions?.length">No sessions!</div>
        <ng-container *ngFor="let programDay of p.sessions; trackBy: trackByIndex">
          <ng-container *ngFor="let sessionId of programDay.sessions">
            <ng-container *ngIf="p.sessions_obj[sessionId]?.type != 'break' && p.sessions_obj[sessionId] as s">
              <div class="session" *ngIf="p && { date: p | programDayDate:programDay.day:true, tagData: (s.attendeeTags || []) | entityIdsToTagData:attendees } as sVars">
                <div class="times">
                  <h4 [ngClass]="{ missing: !s.title }">{{ s.title || 'Untitled Session' }}</h4>&nbsp;&nbsp;|&nbsp;&nbsp;<h5>{{ s.start }} - {{ s.end }}, {{ sVars.date }}</h5>
                  &nbsp;&nbsp;|&nbsp;&nbsp;Number of attendees: {{ sVars.tagData.length }}
                </div>
                <tags
                  [noTitle]="true"
                  [titleIcon]="''"
                  [tags]="sVars.tagData"
                  [title]="''"
                  [showPhoto]="true"
                  [emptyText]="'No attendees tagged'"
                  [readOnly]="readOnly"
                  [tagText]="'+ ADD ATTENDEES'"
                  (remove)="removeTag(s, p.id, $event)"
                  (open)="openTagger.emit({ event: $event, session: s, programId: p.id })"
                ></tags>
              </div>
            </ng-container><!--End session-->
          </ng-container>
        </ng-container><!-- End program day -->
      </expanding-wrapper>
    </ng-container><!--End program-->
  </shared-timeline-wrapper>
</branding-wrapper>
